export const translations = {
  it: {
    brand: "SS Europa by Amei",
    tagline: "Sostegno e Soluzioni per l'Europa",
    nav: { home: "Home", about: "Chi Siamo", register: "Iscrizione", zoom: "Orari e Link", exercises: "Esercizi", translator: "Traduttore" },
    hero: {
      badge: "Associazione Culturale • Italia",
      title: "Impara l'Italiano.",
      titleAccent: "Costruisci il tuo futuro.",
      subtitle: "Corsi live su Google Meet, esercizi illimitati dal livello A0 al B2 e supporto multilingue per la comunità Punjabi, Hindi, Urdu ed English in Italia.",
      ctaPrimary: "Iscriviti Ora — €30",
      ctaSecondary: "Prova gli Esercizi",
    },
    about: {
      title: "Chi Siamo",
      body: "Noi siamo SS Europa by Amei — Sostegno e Soluzioni per l'Europa — un'associazione culturale nata per aiutare più persone possibili a imparare la lingua italiana. Accompagniamo immigrati e nuovi cittadini della comunità Punjabi, Hindi, Urdu e Inglese nel loro percorso di integrazione con corsi live, esercizi pratici, un traduttore intelligente e la nostra assistente virtuale Chikoo. Il nostro obiettivo è rendere l'italiano accessibile, semplice e vicino a chi costruisce ogni giorno il proprio futuro in Italia.",
      pillars: [
        { t: "Integrazione", d: "Supporto culturale e linguistico per la vita quotidiana in Italia." },
        { t: "Inclusione", d: "Insegnamento multilingue: parliamo la tua lingua per aiutarti nella nostra." },
        { t: "Comunità", d: "Una famiglia europea che cammina insieme, passo dopo passo." },
      ],
    },
    features: {
      f1Title: "Corsi Live su Google Meet", f1Desc: "Due fasce orarie: 10:00–11:00 o 18:00–19:00.",
      f2Title: "Esercizi A0 → B2", f2Desc: "Illimitati, facili, generati per te ogni volta che vuoi.",
      f3Title: "Chikoo, la tua guida AI", f3Desc: "Assistente multilingue che ti aiuta e traduce 24/7.",
    },
    form: {
      title: "Modulo di Iscrizione",
      subtitle: "Compila tutti i campi obbligatori. La quota associativa è di €30.",
      nome: "Nome", cognome: "Cognome", dataNascita: "Data di Nascita", cittadinanza: "Cittadinanza",
      indirizzo: "Indirizzo di Residenza", orario: "Orario del Corso", orarioMorning: "Mattina 10:00 – 11:00", orarioEvening: "Sera 18:00 – 19:00",
      email: "Email", cellulare: "Numero di Cellulare", consenso: "Acconsento al trattamento dei miei dati personali (GDPR).",
      firma: "Firma Digitale", firmaHelp: "Firma con il dito o il mouse nel riquadro qui sotto.",
      clear: "Cancella firma", submit: "Procedi al Pagamento (€30)", required: "Campo obbligatorio", creating: "Creazione in corso...",
    },
    payment: {
      successTitle: "Pagamento Confermato!",
      successDesc: "Grazie per esserti iscritto ai corsi di SS Europa by Amei. Riceverai i dettagli via email.",
      cancelTitle: "Pagamento Annullato", cancelDesc: "Puoi riprovare in qualunque momento.",
      goHome: "Torna alla Home", goZoom: "Vai ai Corsi Google Meet", verifying: "Verifica pagamento in corso...",
      viewReceipt: "Visualizza / Stampa Ricevuta", print: "Stampa ricevuta",
      receiptTitle: "Ricevuta di Iscrizione",
    },
    zoom: {
      title: "I Nostri Corsi Google Meet", subtitle: "Clicca sul link per collegarti alla lezione live.",
      morning: "Corso Mattina", evening: "Corso Sera",
      morningTime: "10:00 – 11:00 • Lun–Ven", eveningTime: "18:00 – 19:00 • Lun–Ven",
      join: "Partecipa alla lezione Google Meet", noLink: "Link in arrivo — contatta l'associazione",
    },
    exercises: {
      title: "Esercizi di Italiano", subtitle: "Solo in italiano. Scegli il tuo livello e sblocca sempre nuove sfide.",
      locked: "Bloccato", unlocked: "Sbloccato", completed: "Completato",
      start: "Inizia", nextExercise: "Prossimo esercizio", generating: "Generazione in corso...",
      correct: "Corretta!", wrong: "Riprova.", checkAnswer: "Verifica risposta",
      hint: "Suggerimento", progress: "Progresso",
      unlockRequired: "Completa 5 esercizi nel livello precedente per sbloccare.",
      levelDone: "5 completati! Livello successivo sbloccato.",
      pickLevel: "Scegli un livello",
    },
    translator: {
      title: "Traduttore Multilingue", subtitle: "Traduci tra italiano, inglese, punjabi, hindi e urdu.",
      inputPlaceholder: "Scrivi qui la frase da tradurre...", from: "Da", to: "A",
      translate: "Traduci", copying: "Copiato!", copy: "Copia", swap: "Scambia lingue", loading: "Traduzione in corso...",
      listen: "Ascolta pronuncia", listening: "Audio in caricamento...",
    },
    assistant: {
      title: "Chikoo", subtitle: "La tua guida amichevole • Multilingue",
      placeholder: "Scrivi un messaggio...", send: "Invia",
      greeting: "Ciao! Sono Chikoo, la tua guida di SS Europa. Come posso aiutarti oggi?",
      quickHelp: "Come ti chiami?",
    },
    admin: {
      title: "Pannello Admin", tokenLabel: "Token Admin", login: "Entra",
      zoomTitle: "Link Google Meet", morningLink: "Link Google Meet Mattina", eveningLink: "Link Google Meet Sera",
      saveLinks: "Salva Link", regsTitle: "Iscrizioni",
    },
    footer: {
      contact: "Contatti", visit: "Visita il sito", website: "www.sseuropa.com",
      rights: "© 2026 SS Europa by Amei · Associazione Culturale",
    },
  },
  en: {
    brand: "SS Europa by Amei",
    tagline: "Support and Solutions for Europe",
    nav: { home: "Home", about: "About Us", register: "Register", zoom: "Schedule", exercises: "Exercises", translator: "Translator" },
    hero: {
      badge: "Cultural Association • Italy",
      title: "Learn Italian.",
      titleAccent: "Build your future.",
      subtitle: "Live Google Meet classes, unlimited exercises from A0 to B2, and multilingual support for the Punjabi, Hindi, Urdu and English-speaking community in Italy.",
      ctaPrimary: "Register Now — €30", ctaSecondary: "Try the Exercises",
    },
    about: {
      title: "About Us",
      body: "We are SS Europa by Amei — Support and Solutions for Europe — a cultural association born to help as many people as possible learn the Italian language. We walk alongside immigrants and new citizens from the Punjabi, Hindi, Urdu and English-speaking communities on their integration journey with live classes, practical exercises, a smart translator and our virtual guide Chikoo. Our goal is to make Italian accessible, simple and close to those who build their future in Italy every day.",
      pillars: [
        { t: "Integration", d: "Cultural and linguistic support for everyday life in Italy." },
        { t: "Inclusion", d: "Multilingual teaching: we speak your language to help you learn ours." },
        { t: "Community", d: "A European family walking together, one step at a time." },
      ],
    },
    features: {
      f1Title: "Live Google Meet Classes", f1Desc: "Two time slots: 10:00–11:00 or 18:00–19:00.",
      f2Title: "Exercises A0 → B2", f2Desc: "Unlimited, easy, freshly generated whenever you want.",
      f3Title: "Chikoo, your AI guide", f3Desc: "Multilingual assistant that helps and translates 24/7.",
    },
    form: {
      title: "Registration Form", subtitle: "Complete all required fields. Membership fee is €30.",
      nome: "First Name", cognome: "Last Name", dataNascita: "Date of Birth", cittadinanza: "Citizenship",
      indirizzo: "Residential Address", orario: "Course Time", orarioMorning: "Morning 10:00 – 11:00 AM", orarioEvening: "Evening 6:00 – 7:00 PM",
      email: "Email", cellulare: "Mobile Number", consenso: "I consent to the processing of my personal data (GDPR).",
      firma: "Digital Signature", firmaHelp: "Sign with finger or mouse in the box below.",
      clear: "Clear signature", submit: "Proceed to Payment (€30)", required: "Required field", creating: "Creating...",
    },
    payment: {
      successTitle: "Payment Confirmed!", successDesc: "Thanks for registering with SS Europa by Amei. Details will arrive by email.",
      cancelTitle: "Payment Cancelled", cancelDesc: "You can try again at any time.",
      goHome: "Back Home", goZoom: "Go to Google Meet Courses", verifying: "Verifying payment...",
      viewReceipt: "View / Print Receipt", print: "Print receipt",
      receiptTitle: "Registration Receipt",
    },
    zoom: {
      title: "Our Google Meet Courses", subtitle: "Click the link to join the live class.",
      morning: "Morning Course", evening: "Evening Course",
      morningTime: "10:00 – 11:00 AM • Mon–Fri", eveningTime: "6:00 – 7:00 PM • Mon–Fri",
      join: "Join Google Meet class", noLink: "Link coming — contact the association",
    },
    exercises: {
      title: "Italian Exercises", subtitle: "In Italian only. Choose your level and unlock endless new challenges.",
      locked: "Locked", unlocked: "Unlocked", completed: "Completed",
      start: "Start", nextExercise: "Next exercise", generating: "Generating...",
      correct: "Correct!", wrong: "Try again.", checkAnswer: "Check answer",
      hint: "Hint", progress: "Progress",
      unlockRequired: "Complete 5 exercises in the previous level to unlock.",
      levelDone: "5 completed! Next level unlocked.",
      pickLevel: "Pick a level",
    },
    translator: {
      title: "Multilingual Translator", subtitle: "Translate between IT, EN, Punjabi, Hindi and Urdu.",
      inputPlaceholder: "Type the sentence to translate...", from: "From", to: "To",
      translate: "Translate", copying: "Copied!", copy: "Copy", swap: "Swap languages", loading: "Translating...",
      listen: "Listen pronunciation", listening: "Loading audio...",
    },
    assistant: {
      title: "Chikoo", subtitle: "Your friendly guide • Multilingual",
      placeholder: "Type a message...", send: "Send",
      greeting: "Hi! I'm Chikoo, your SS Europa guide. How can I help you today?",
      quickHelp: "What's your name?",
    },
    admin: { title: "Admin Panel", tokenLabel: "Admin Token", login: "Enter", zoomTitle: "Google Meet Links", morningLink: "Morning Google Meet Link", eveningLink: "Evening Google Meet Link", saveLinks: "Save Links", regsTitle: "Registrations" },
    footer: { contact: "Contact", visit: "Visit website", website: "www.sseuropa.com", rights: "© 2026 SS Europa by Amei · Cultural Association" },
  },
  pa: {
    brand: "SS Europa by Amei",
    tagline: "ਯੂਰਪ ਲਈ ਸਹਾਇਤਾ ਅਤੇ ਹੱਲ",
    nav: { home: "ਹੋਮ", about: "ਸਾਡੇ ਬਾਰੇ", register: "ਰਜਿਸਟਰ", zoom: "Google Meet ਕਲਾਸਾਂ", exercises: "ਅਭਿਆਸ", translator: "ਅਨੁਵਾਦਕ" },
    hero: {
      badge: "ਸੱਭਿਆਚਾਰਕ ਸੰਸਥਾ • ਇਟਲੀ",
      title: "ਇਤਾਲਵੀ ਸਿੱਖੋ।",
      titleAccent: "ਆਪਣਾ ਭਵਿੱਖ ਬਣਾਓ।",
      subtitle: "ਇਟਲੀ ਵਿੱਚ ਪੰਜਾਬੀ, ਹਿੰਦੀ, ਉਰਦੂ ਅਤੇ ਅੰਗ੍ਰੇਜ਼ੀ ਭਾਈਚਾਰੇ ਲਈ ਲਾਈਵ Google Meet ਕੋਰਸ, A0 ਤੋਂ B2 ਤੱਕ ਬੇਅੰਤ ਅਭਿਆਸ ਅਤੇ ਬਹੁ-ਭਾਸ਼ੀ ਸਹਾਇਤਾ।",
      ctaPrimary: "ਹੁਣੇ ਰਜਿਸਟਰ ਕਰੋ — €30", ctaSecondary: "ਅਭਿਆਸ ਅਜ਼ਮਾਓ",
    },
    about: {
      title: "ਸਾਡੇ ਬਾਰੇ",
      body: "ਅਸੀਂ SS Europa by Amei ਹਾਂ — ਯੂਰਪ ਲਈ ਸਹਾਇਤਾ ਅਤੇ ਹੱਲ — ਇੱਕ ਸੱਭਿਆਚਾਰਕ ਸੰਸਥਾ ਜੋ ਵੱਧ ਤੋਂ ਵੱਧ ਲੋਕਾਂ ਨੂੰ ਇਤਾਲਵੀ ਭਾਸ਼ਾ ਸਿੱਖਣ ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਬਣੀ ਹੈ। ਅਸੀਂ ਪੰਜਾਬੀ, ਹਿੰਦੀ, ਉਰਦੂ ਅਤੇ ਅੰਗ੍ਰੇਜ਼ੀ ਭਾਈਚਾਰੇ ਦੇ ਪ੍ਰਵਾਸੀਆਂ ਦੇ ਨਾਲ ਲਾਈਵ ਕਲਾਸਾਂ, ਅਭਿਆਸ, ਸਮਾਰਟ ਅਨੁਵਾਦਕ ਅਤੇ ਸਾਡੀ ਵਰਚੁਅਲ ਗਾਈਡ Chikoo ਨਾਲ ਚੱਲਦੇ ਹਾਂ।",
      pillars: [
        { t: "ਏਕੀਕਰਨ", d: "ਇਟਲੀ ਵਿੱਚ ਰੋਜ਼ਾਨਾ ਜੀਵਨ ਲਈ ਸੱਭਿਆਚਾਰਕ ਸਹਾਇਤਾ।" },
        { t: "ਸ਼ਮੂਲੀਅਤ", d: "ਬਹੁ-ਭਾਸ਼ੀ ਸਿੱਖਿਆ: ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ।" },
        { t: "ਭਾਈਚਾਰਾ", d: "ਇੱਕ ਯੂਰਪੀ ਪਰਿਵਾਰ, ਇਕੱਠੇ ਚੱਲਦਾ ਹੈ।" },
      ],
    },
    features: {
      f1Title: "ਲਾਈਵ Google Meet ਕਲਾਸਾਂ", f1Desc: "ਦੋ ਸਮੇਂ: 10:00–11:00 ਜਾਂ 18:00–19:00।",
      f2Title: "ਅਭਿਆਸ A0 → B2", f2Desc: "ਬੇਅੰਤ, ਆਸਾਨ, ਹਰ ਵਾਰ ਤਾਜ਼ੇ।",
      f3Title: "Chikoo, ਤੁਹਾਡੀ AI ਗਾਈਡ", f3Desc: "24/7 ਮਦਦ ਅਤੇ ਅਨੁਵਾਦ ਲਈ।",
    },
    form: {
      title: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫਾਰਮ", subtitle: "ਸਾਰੇ ਲੋੜੀਂਦੇ ਫੀਲਡ ਭਰੋ। ਫੀਸ €30 ਹੈ।",
      nome: "ਪਹਿਲਾ ਨਾਮ", cognome: "ਆਖਰੀ ਨਾਮ", dataNascita: "ਜਨਮ ਮਿਤੀ", cittadinanza: "ਨਾਗਰਿਕਤਾ",
      indirizzo: "ਪਤਾ", orario: "ਕੋਰਸ ਸਮਾਂ", orarioMorning: "ਸਵੇਰ 10:00 – 11:00", orarioEvening: "ਸ਼ਾਮ 18:00 – 19:00",
      email: "ਈਮੇਲ", cellulare: "ਮੋਬਾਈਲ", consenso: "ਮੈਂ GDPR ਲਈ ਸਹਿਮਤੀ ਦਿੰਦਾ ਹਾਂ।",
      firma: "ਦਸਤਖ਼ਤ", firmaHelp: "ਹੇਠਾਂ ਦਸਤਖ਼ਤ ਕਰੋ।",
      clear: "ਸਾਫ਼ ਕਰੋ", submit: "ਭੁਗਤਾਨ (€30)", required: "ਲੋੜੀਂਦਾ", creating: "ਬਣਾ ਰਿਹਾ...",
    },
    payment: {
      successTitle: "ਭੁਗਤਾਨ ਪੁਸ਼ਟੀ ਹੋਇਆ!", successDesc: "ਧੰਨਵਾਦ। ਵੇਰਵੇ ਈਮੇਲ ਰਾਹੀਂ ਭੇਜੇ ਜਾਣਗੇ।",
      cancelTitle: "ਭੁਗਤਾਨ ਰੱਦ", cancelDesc: "ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      goHome: "ਹੋਮ", goZoom: "Google Meet", verifying: "ਪੁਸ਼ਟੀ ਹੋ ਰਹੀ...",
      viewReceipt: "ਰਸੀਦ ਦੇਖੋ / ਛਾਪੋ", print: "ਛਾਪੋ",
      receiptTitle: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਰਸੀਦ",
    },
    zoom: {
      title: "ਸਾਡੀਆਂ Google Meet ਕਲਾਸਾਂ", subtitle: "ਲਿੰਕ ਤੇ ਕਲਿੱਕ ਕਰੋ।",
      morning: "ਸਵੇਰ ਦਾ ਕੋਰਸ", evening: "ਸ਼ਾਮ ਦਾ ਕੋਰਸ",
      morningTime: "10:00 – 11:00 • ਸੋਮ–ਸ਼ੁੱਕਰ", eveningTime: "18:00 – 19:00 • ਸੋਮ–ਸ਼ੁੱਕਰ",
      join: "Google Meet ਵਿੱਚ ਸ਼ਾਮਿਲ ਹੋਵੋ", noLink: "ਲਿੰਕ ਜਲਦੀ ਆ ਰਿਹਾ",
    },
    exercises: {
      title: "ਇਤਾਲਵੀ ਅਭਿਆਸ", subtitle: "ਇਤਾਲਵੀ ਵਿੱਚ। ਪੱਧਰ ਚੁਣੋ।",
      locked: "ਲੌਕ", unlocked: "ਅਨਲੌਕ", completed: "ਪੂਰਾ",
      start: "ਸ਼ੁਰੂ", nextExercise: "ਅਗਲਾ ਅਭਿਆਸ", generating: "ਬਣ ਰਿਹਾ...",
      correct: "ਸਹੀ!", wrong: "ਦੁਬਾਰਾ।", checkAnswer: "ਜਵਾਬ ਚੈੱਕ ਕਰੋ",
      hint: "ਸੰਕੇਤ", progress: "ਤਰੱਕੀ",
      unlockRequired: "ਪਿਛਲੇ ਪੱਧਰ ਵਿੱਚ 5 ਪੂਰੇ ਕਰੋ।",
      levelDone: "5 ਪੂਰੇ! ਅਗਲਾ ਪੱਧਰ ਅਨਲੌਕ।",
      pickLevel: "ਪੱਧਰ ਚੁਣੋ",
    },
    translator: {
      title: "ਬਹੁ-ਭਾਸ਼ੀ ਅਨੁਵਾਦਕ", subtitle: "IT, EN, ਪੰਜਾਬੀ, ਹਿੰਦੀ, ਉਰਦੂ ਵਿਚਕਾਰ।",
      inputPlaceholder: "ਵਾਕ ਲਿਖੋ...", from: "ਤੋਂ", to: "ਤੱਕ",
      translate: "ਅਨੁਵਾਦ", copying: "ਕਾਪੀ!", copy: "ਕਾਪੀ", swap: "ਬਦਲੋ", loading: "ਹੋ ਰਿਹਾ...",
      listen: "ਸੁਣੋ", listening: "ਲੋਡ ਹੋ ਰਿਹਾ...",
    },
    assistant: {
      title: "Chikoo", subtitle: "ਤੁਹਾਡੀ ਦੋਸਤਾਨਾ ਗਾਈਡ",
      placeholder: "ਸੁਨੇਹਾ ਲਿਖੋ...", send: "ਭੇਜੋ",
      greeting: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ! ਮੈਂ Chikoo ਹਾਂ। ਕਿਵੇਂ ਮਦਦ ਕਰਾਂ?",
      quickHelp: "ਤੁਹਾਡਾ ਨਾਮ?",
    },
    admin: { title: "ਐਡਮਿਨ", tokenLabel: "ਟੋਕਨ", login: "ਦਾਖਲ", zoomTitle: "Google Meet ਲਿੰਕ", morningLink: "ਸਵੇਰ", eveningLink: "ਸ਼ਾਮ", saveLinks: "ਸੰਭਾਲੋ", regsTitle: "ਰਜਿਸਟ੍ਰੇਸ਼ਨਾਂ" },
    footer: { contact: "ਸੰਪਰਕ", visit: "ਸਾਈਟ ਵੇਖੋ", website: "www.sseuropa.com", rights: "© 2026 SS Europa by Amei" },
  },
  hi: {
    brand: "SS Europa by Amei",
    tagline: "यूरोप के लिए सहायता और समाधान",
    nav: { home: "होम", about: "हमारे बारे में", register: "पंजीकरण", zoom: "Google Meet कोर्स", exercises: "अभ्यास", translator: "अनुवादक" },
    hero: {
      badge: "सांस्कृतिक संस्था • इटली",
      title: "इतालवी सीखें।",
      titleAccent: "अपना भविष्य बनाएँ।",
      subtitle: "इटली में पंजाबी, हिन्दी, उर्दू और अंग्रेज़ी भाषी समुदाय के लिए लाइव Google Meet कोर्स, A0 से B2 तक असीमित अभ्यास और बहुभाषी सहायता।",
      ctaPrimary: "अभी पंजीकरण करें — €30", ctaSecondary: "अभ्यास आज़माएँ",
    },
    about: {
      title: "हमारे बारे में",
      body: "हम SS Europa by Amei हैं — यूरोप के लिए सहायता और समाधान — एक सांस्कृतिक संस्था जो अधिक से अधिक लोगों को इतालवी भाषा सीखने में मदद करने के लिए बनी है। हम पंजाबी, हिन्दी, उर्दू और अंग्रेज़ी बोलने वाले समुदाय के अप्रवासियों के साथ लाइव क्लास, अभ्यास, स्मार्ट अनुवादक और हमारी वर्चुअल गाइड Chikoo के साथ चलते हैं।",
      pillars: [
        { t: "एकीकरण", d: "इटली में रोज़मर्रा के जीवन के लिए सहायता।" },
        { t: "समावेश", d: "बहुभाषी शिक्षा: आपकी भाषा में।" },
        { t: "समुदाय", d: "एक यूरोपीय परिवार, एक साथ आगे बढ़ता है।" },
      ],
    },
    features: {
      f1Title: "लाइव Google Meet क्लासेस", f1Desc: "दो समय: 10:00–11:00 या 18:00–19:00।",
      f2Title: "अभ्यास A0 → B2", f2Desc: "असीमित, आसान, हर बार नए।",
      f3Title: "Chikoo, आपकी AI गाइड", f3Desc: "24/7 मदद और अनुवाद।",
    },
    form: {
      title: "पंजीकरण फ़ॉर्म", subtitle: "सभी फ़ील्ड भरें। शुल्क €30।",
      nome: "पहला नाम", cognome: "अंतिम नाम", dataNascita: "जन्म तिथि", cittadinanza: "नागरिकता",
      indirizzo: "पता", orario: "कोर्स समय", orarioMorning: "सुबह 10:00 – 11:00", orarioEvening: "शाम 18:00 – 19:00",
      email: "ईमेल", cellulare: "मोबाइल", consenso: "मैं GDPR सहमति देता/देती हूँ।",
      firma: "हस्ताक्षर", firmaHelp: "नीचे बॉक्स में हस्ताक्षर करें।",
      clear: "साफ़ करें", submit: "भुगतान (€30)", required: "आवश्यक", creating: "बनाया जा रहा...",
    },
    payment: {
      successTitle: "भुगतान पुष्टि!", successDesc: "धन्यवाद। विवरण ईमेल से आएँगे।",
      cancelTitle: "भुगतान रद्द", cancelDesc: "पुनः प्रयास करें।",
      goHome: "होम", goZoom: "Google Meet", verifying: "पुष्टि हो रही...",
      viewReceipt: "रसीद देखें / प्रिंट करें", print: "प्रिंट रसीद",
      receiptTitle: "पंजीकरण रसीद",
    },
    zoom: {
      title: "हमारे Google Meet कोर्स", subtitle: "लिंक पर क्लिक करें।",
      morning: "सुबह का कोर्स", evening: "शाम का कोर्स",
      morningTime: "10:00 – 11:00 • सोम–शुक्र", eveningTime: "18:00 – 19:00 • सोम–शुक्र",
      join: "Google Meet में शामिल हों", noLink: "लिंक जल्द",
    },
    exercises: {
      title: "इतालवी अभ्यास", subtitle: "इतालवी में। स्तर चुनें।",
      locked: "लॉक", unlocked: "अनलॉक", completed: "पूर्ण",
      start: "शुरू", nextExercise: "अगला अभ्यास", generating: "बना रहा...",
      correct: "सही!", wrong: "फिर कोशिश।", checkAnswer: "जवाब जाँचें",
      hint: "संकेत", progress: "प्रगति",
      unlockRequired: "पिछले स्तर में 5 पूरे करें।",
      levelDone: "5 पूरे! अगला स्तर अनलॉक।",
      pickLevel: "स्तर चुनें",
    },
    translator: {
      title: "बहुभाषी अनुवादक", subtitle: "IT, EN, पंजाबी, हिन्दी, उर्दू के बीच।",
      inputPlaceholder: "वाक्य लिखें...", from: "से", to: "तक",
      translate: "अनुवाद", copying: "कॉपी!", copy: "कॉपी", swap: "बदलें", loading: "हो रहा...",
      listen: "उच्चारण सुनें", listening: "लोड हो रहा...",
    },
    assistant: {
      title: "Chikoo", subtitle: "आपकी दोस्ताना गाइड",
      placeholder: "संदेश लिखें...", send: "भेजें",
      greeting: "नमस्ते! मैं Chikoo हूँ। कैसे मदद करूँ?",
      quickHelp: "आपका नाम?",
    },
    admin: { title: "एडमिन", tokenLabel: "टोकन", login: "प्रवेश", zoomTitle: "Google Meet लिंक", morningLink: "सुबह", eveningLink: "शाम", saveLinks: "सहेजें", regsTitle: "पंजीकरण" },
    footer: { contact: "संपर्क", visit: "साइट देखें", website: "www.sseuropa.com", rights: "© 2026 SS Europa by Amei" },
  },
  ur: {
    brand: "SS Europa by Amei",
    tagline: "یورپ کے لیے سپورٹ اور حل",
    nav: { home: "ہوم", about: "ہمارے بارے میں", register: "رجسٹریشن", zoom: "گوگل میٹ کورس", exercises: "مشقیں", translator: "مترجم" },
    hero: {
      badge: "ثقافتی انجمن • اٹلی",
      title: "اطالوی سیکھیں۔",
      titleAccent: "اپنا مستقبل بنائیں۔",
      subtitle: "اٹلی میں پنجابی، ہندی، اردو اور انگریزی برادری کے لیے لائیو گوگل میٹ کلاسز، A0 سے B2 تک لامحدود مشقیں اور کثیر لسانی مدد۔",
      ctaPrimary: "ابھی رجسٹر کریں — €30", ctaSecondary: "مشقیں آزمائیں",
    },
    about: {
      title: "ہمارے بارے میں",
      body: "ہم SS Europa by Amei ہیں — یورپ کے لیے سپورٹ اور حل — ایک ثقافتی انجمن جو زیادہ سے زیادہ لوگوں کو اطالوی زبان سیکھنے میں مدد دینے کے لیے قائم کی گئی ہے۔ ہم پنجابی، ہندی، اردو اور انگریزی بولنے والوں کے ساتھ لائیو کلاسز، مشقوں، سمارٹ مترجم اور ہماری ورچوئل گائیڈ Chikoo کے ذریعے چلتے ہیں۔",
      pillars: [
        { t: "انضمام", d: "اٹلی میں روزمرہ زندگی کے لیے مدد۔" },
        { t: "شمولیت", d: "کثیر لسانی تعلیم: آپ کی زبان میں۔" },
        { t: "کمیونٹی", d: "ایک یورپی خاندان، ساتھ چلتا ہے۔" },
      ],
    },
    features: {
      f1Title: "لائیو گوگل میٹ کلاسز", f1Desc: "دو اوقات: 10:00–11:00 یا 18:00–19:00۔",
      f2Title: "مشقیں A0 → B2", f2Desc: "لامحدود، آسان، ہر بار نئی۔",
      f3Title: "Chikoo، آپ کی AI گائیڈ", f3Desc: "24/7 مدد اور ترجمہ۔",
    },
    form: {
      title: "رجسٹریشن فارم", subtitle: "تمام فیلڈز بھریں۔ فیس €30۔",
      nome: "پہلا نام", cognome: "آخری نام", dataNascita: "تاریخ پیدائش", cittadinanza: "شہریت",
      indirizzo: "پتہ", orario: "کورس وقت", orarioMorning: "صبح 10:00 – 11:00", orarioEvening: "شام 18:00 – 19:00",
      email: "ای میل", cellulare: "موبائل", consenso: "میں GDPR سے متفق ہوں۔",
      firma: "دستخط", firmaHelp: "نیچے دستخط کریں۔",
      clear: "صاف کریں", submit: "ادائیگی (€30)", required: "لازمی", creating: "بن رہا ہے...",
    },
    payment: {
      successTitle: "ادائیگی کی تصدیق!", successDesc: "شکریہ۔ تفصیلات ای میل پر۔",
      cancelTitle: "ادائیگی منسوخ", cancelDesc: "دوبارہ کوشش کریں۔",
      goHome: "ہوم", goZoom: "گوگل میٹ", verifying: "تصدیق ہو رہی...",
      viewReceipt: "رسید دیکھیں / پرنٹ کریں", print: "پرنٹ رسید",
      receiptTitle: "رجسٹریشن رسید",
    },
    zoom: {
      title: "ہماری گوگل میٹ کلاسز", subtitle: "لنک پر کلک کریں۔",
      morning: "صبح کا کورس", evening: "شام کا کورس",
      morningTime: "10:00 – 11:00 • سوم–جمعہ", eveningTime: "18:00 – 19:00 • سوم–جمعہ",
      join: "گوگل میٹ میں شامل ہوں", noLink: "لنک جلد",
    },
    exercises: {
      title: "اطالوی مشقیں", subtitle: "اطالوی میں۔ اپنا لیول چنیں۔",
      locked: "لاک", unlocked: "انلاک", completed: "مکمل",
      start: "شروع", nextExercise: "اگلی مشق", generating: "بن رہی...",
      correct: "درست!", wrong: "دوبارہ۔", checkAnswer: "جواب چیک کریں",
      hint: "اشارہ", progress: "پیش رفت",
      unlockRequired: "پچھلے لیول میں 5 مکمل کریں۔",
      levelDone: "5 مکمل! اگلا لیول انلاک۔",
      pickLevel: "لیول چنیں",
    },
    translator: {
      title: "کثیر لسانی مترجم", subtitle: "IT، EN، پنجابی، ہندی، اردو کے درمیان۔",
      inputPlaceholder: "جملہ لکھیں...", from: "سے", to: "تک",
      translate: "ترجمہ", copying: "کاپی!", copy: "کاپی", swap: "بدلیں", loading: "ہو رہا...",
      listen: "تلفظ سنیں", listening: "لوڈ ہو رہا...",
    },
    assistant: {
      title: "Chikoo", subtitle: "آپ کی دوستانہ گائیڈ",
      placeholder: "پیغام لکھیں...", send: "بھیجیں",
      greeting: "سلام! میں Chikoo ہوں۔ کیسے مدد کروں؟",
      quickHelp: "آپ کا نام؟",
    },
    admin: { title: "ایڈمن", tokenLabel: "ٹوکن", login: "داخل ہوں", zoomTitle: "گوگل میٹ لنکس", morningLink: "صبح", eveningLink: "شام", saveLinks: "محفوظ کریں", regsTitle: "رجسٹریشنز" },
    footer: { contact: "رابطہ", visit: "سائٹ دیکھیں", website: "www.sseuropa.com", rights: "© 2026 SS Europa by Amei" },
  },
  pa_lat: {
    brand: "SS Europa by Amei",
    tagline: "Europe layi Support te Solutions",
    nav: { home: "Home", about: "Saade Baare", register: "Registration", zoom: "Google Meet Class", exercises: "Abhyaas", translator: "Translator" },
    hero: {
      badge: "Cultural Association • Italy",
      title: "Italian sikho.",
      titleAccent: "Apna future banao.",
      subtitle: "Italy vich Punjabi, Hindi, Urdu te English bolan valian layi live Google Meet class, A0 ton B2 tak unlimited abhyaas te multi-language madad.",
      ctaPrimary: "Hune Register Karo — €30",
      ctaSecondary: "Abhyaas Try Karo",
    },
    about: {
      title: "Saade Baare",
      body: "Assi SS Europa by Amei haan — Europe layi Support te Solutions — ik cultural association jehri jyada ton jyada lokan nu Italian sikhaan vich madad karan layi bani hai. Assi Punjabi, Hindi, Urdu te English bolan vale immigrants naal live class, abhyaas, smart translator te saadi virtual guide Chikoo raahin chalde haan. Saada maqsad hai Italian nu asaan te sabh layi mumkin banaana.",
      pillars: [
        { t: "Integration", d: "Italy di rozana zindagi layi madad." },
        { t: "Inclusion", d: "Multi-language teaching — tuhaadi bhasha vich." },
        { t: "Community", d: "Ik European parivar, ikathe chalda hai." },
      ],
    },
    features: {
      f1Title: "Live Google Meet Class", f1Desc: "Do time: 10:00–11:00 ja 18:00–19:00.",
      f2Title: "Abhyaas A0 → B2", f2Desc: "Unlimited, asaan, har vaari naveen.",
      f3Title: "Chikoo, tuhadi AI guide", f3Desc: "24/7 madad te translation.",
    },
    form: {
      title: "Registration Form",
      subtitle: "Saare zaruri field bharo. Fees €30.",
      nome: "Naam", cognome: "Khaandaani naam", dataNascita: "Janam tareek", cittadinanza: "Nagrikta",
      indirizzo: "Ghar da pata", orario: "Class da time", orarioMorning: "Savere 10:00 – 11:00", orarioEvening: "Shaam 18:00 – 19:00",
      email: "Email", cellulare: "Mobile number", consenso: "Main GDPR nu maanda haan.",
      firma: "Digital signature", firmaHelp: "Hethaan sign karo.",
      clear: "Saaf karo", submit: "Payment karo (€30)", required: "Zaruri field", creating: "Ban riha hai...",
    },
    payment: {
      successTitle: "Payment ho gayi!", successDesc: "Shukriya! Vervaa email te aayenge.",
      cancelTitle: "Payment cancel", cancelDesc: "Dubaara koshish karo.",
      goHome: "Home", goZoom: "Google Meet", verifying: "Verify ho riha...",
      viewReceipt: "Receipt vekho / print karo", print: "Print receipt",
      receiptTitle: "Registration Receipt",
    },
    zoom: {
      title: "Saadian Google Meet Class", subtitle: "Link te click karo.",
      morning: "Savere di class", evening: "Shaam di class",
      morningTime: "10:00 – 11:00 • Som–Shukkar", eveningTime: "18:00 – 19:00 • Som–Shukkar",
      join: "Google Meet class vich shaamil ho", noLink: "Link jaldi aa reha",
    },
    exercises: {
      title: "Italian Abhyaas", subtitle: "Italian vich. Apna level chuno.",
      locked: "Lock", unlocked: "Unlock", completed: "Poora",
      start: "Shuru karo", nextExercise: "Agla abhyaas", generating: "Ban riha hai...",
      correct: "Sahi!", wrong: "Dubaara koshish karo.", checkAnswer: "Jawaab check karo",
      hint: "Hint", progress: "Progress",
      unlockRequired: "Pichhle level vich 5 poore karo.",
      levelDone: "5 poore! Agla level unlock ho gaya.",
      pickLevel: "Level chuno",
    },
    translator: {
      title: "Multi-language Translator", subtitle: "IT, EN, Punjabi, Hindi, Urdu vichkaar.",
      inputPlaceholder: "Yahan jumla likho...", from: "Ton", to: "Tak",
      translate: "Translate karo", copying: "Copy!", copy: "Copy", swap: "Bhashaan badlo", loading: "Ho riha hai...",
      listen: "Bol ke sunno", listening: "Audio load ho reha...",
    },
    assistant: {
      title: "Chikoo", subtitle: "Tuhaadi dostana guide",
      placeholder: "Message likho...", send: "Bhejo",
      greeting: "Sat Sri Akal! Main Chikoo haan, SS Europa di virtual guide. Aaj kis vich madad kara?",
      quickHelp: "Tuhada naam?",
    },
    admin: { title: "Admin Panel", tokenLabel: "Admin Token", login: "Enter", zoomTitle: "Google Meet Links", morningLink: "Savere da Google Meet link", eveningLink: "Shaam da Google Meet link", saveLinks: "Save karo", regsTitle: "Registrations" },
    footer: { contact: "Contact", visit: "Site vekho", website: "www.sseuropa.com", rights: "© 2026 SS Europa by Amei" },
  },
};

export const LANGS = [
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "en", label: "English", flag: "EN" },
  { code: "pa", label: "ਪੰਜਾਬੀ", flag: "PA" },
  { code: "pa_lat", label: "Punjabi (Roman)", flag: "PA*" },
  { code: "hi", label: "हिन्दी", flag: "HI" },
  { code: "ur", label: "اردو", flag: "UR" },
];

export const RTL_LANGS = new Set(["ur"]);
